import { useEffect } from 'react';
import { useMinimizableModal } from '../use-minimizable-modal';

export const useNestedModalDetector = () => {
	const { setIsNestedModal } = useMinimizableModal();

	useEffect(() => {
		const modalElements: NodeListOf<Element> = document.querySelectorAll(
			'div.atlaskit-portal [aria-modal="true"]',
		);
		if (modalElements.length > 1) {
			setIsNestedModal(true);
		}
	}, [setIsNestedModal]);
};
